import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useTranslation } from '../hooks/useTranslation';
import { useLanguage } from '../contexts/LanguageContext';
import { withLang } from '../components/LanguageRouter';

const CookiePolicy = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="pt-24 pb-16">
        <div className="container mx-auto px-4">
          {/* Navigation Bar */}
          <div className="mb-6 flex items-center justify-between">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center text-blue-600 hover:text-blue-800 transition-colors duration-200"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              {t('legal.goBack')}
            </button>
            <Link
              to={withLang(currentLanguage)}
              className="flex items-center text-gray-600 hover:text-blue-600 transition-colors duration-200"
            >
              <Home className="w-5 h-5 mr-2" />
              {t('footer.home')}
            </Link>
          </div>

          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8">
            <h1 className="text-4xl font-bold text-blue-900 mb-8">{t('legal.cookies.title')}</h1>
            <p className="text-gray-600 mb-8">{t('legal.lastUpdated')}</p>

            <div className="space-y-8">
              <section>
                <h2 className="text-2xl font-bold text-blue-900 mb-4">{t('legal.cookies.section1.title')}</h2>
                <p className="text-gray-700 leading-relaxed">
                  {t('legal.cookies.section1.content')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-blue-900 mb-4">{t('legal.cookies.section2.title')}</h2>
                <div className="space-y-4">
                  <div className="bg-blue-50 p-4 rounded-lg">
                    <p className="text-gray-700"><strong>{t('legal.cookies.section2.essential')}</strong></p>
                  </div>
                  <div className="bg-slate-100 p-4 rounded-lg">
                    <p className="text-gray-700"><strong>{t('legal.cookies.section2.analytics')}</strong></p>
                  </div>
                  <div className="bg-yellow-50 p-4 rounded-lg">
                    <p className="text-gray-700"><strong>{t('legal.cookies.section2.preferences')}</strong></p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-blue-900 mb-4">{t('legal.cookies.section3.title')}</h2>
                <p className="text-gray-700 leading-relaxed">
                  {t('legal.cookies.section3.content')}
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CookiePolicy;